export const CLASS_VALIDATE_ERROR = ['is-invalid', 'active-error'];
export const CLASS_VALIDATE_ERROR_INLINE = CLASS_VALIDATE_ERROR.join(' ');
export const REGEX_LATITUDE = /^(\\+|-)?(?:90(?:(?:\.0{1,20})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,20})?))$/;
export const REGEX_LONGITUDE = /^(\\+|-)?(?:180(?:(?:\.0{1,20})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,20})?))$/;
export const SS_PUSH_NOTIFICATION_LICENSES = 'ss.push.notification.licenses';
export const IS_SHOW_NOTIFICATION = 'is_show_push_notification';
export const IS_SET_FCM_TOKEN_TO_SERVER = 'is_set_fcm_token_to_server';

if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

$('.modal').modal({
    keyboard: false,
    backdrop: 'static',
    show: false
});

document.querySelectorAll('select').forEach(function (element) {
    handleColorSelect(element)
})

$(document).on('change', 'select', function () {
    handleColorSelect(this)
})

function handleColorSelect(element) {
    if ($(element).val()) {
        element.classList.remove('text-disabled');
        element.classList.add('text-dark');
    } else {
        element.classList.add('text-disabled');
    }
}

// window.addEventListener('storage', (event) => {
//     const isEnableNotification = isEnableShowNotification();
//     const licenseIdsPushNotification = getLicenseIdsPushNotification();
//     if (licenseIdsPushNotification.length > 0) {
//         saveLicenseIdsPushNotification(licenseIdsPushNotification);
//     }
//     if (isEnableNotification !== null) {
//         setShowNotification(isEnableNotification);
//     }
// });

export function setShowNotification(value) {
    localStorage.setItem(IS_SHOW_NOTIFICATION, JSON.stringify(value));
    sessionStorage.setItem(IS_SHOW_NOTIFICATION, JSON.stringify(value));
}

export function removeItemNotificationLicense(value) {
    const ids = getLicenseIdsPushNotification();
    let newIds = [...ids];
    const index = newIds.findIndex((id) => id === value);
    if (index !== -1) {
        newIds.splice(index, 1);
    }
    if (newIds.length > 0) {
        localStorage.setItem(SS_PUSH_NOTIFICATION_LICENSES, JSON.stringify([...newIds]));
        sessionStorage.setItem(SS_PUSH_NOTIFICATION_LICENSES, JSON.stringify([...newIds]));
    } else {
        localStorage.removeItem(SS_PUSH_NOTIFICATION_LICENSES);
        sessionStorage.removeItem(SS_PUSH_NOTIFICATION_LICENSES);
    }
}

export const isEnableShowNotification = () => {
    let localStorageIsShow = localStorage.getItem(IS_SHOW_NOTIFICATION);
    localStorageIsShow = localStorageIsShow && localStorageIsShow !== 'undefined' ? JSON.parse(localStorageIsShow) : null;
    let sessionStorageIsShow = sessionStorage.getItem(IS_SHOW_NOTIFICATION);
    sessionStorageIsShow = sessionStorageIsShow && sessionStorageIsShow !== 'undefined' ? JSON.parse(sessionStorageIsShow) : null;

    return localStorageIsShow || sessionStorageIsShow;
}

export const saveLicenseIdsPushNotification = function saveLicenseIdsPushNotification(ids) {
    let currentIds = localStorage.getItem(SS_PUSH_NOTIFICATION_LICENSES);
    currentIds = currentIds && currentIds !== 'undefined' ? JSON.parse(currentIds) : [];
    let newIds = [...currentIds].concat(ids);
    newIds = [...new Set(newIds)];
    localStorage.setItem(SS_PUSH_NOTIFICATION_LICENSES, JSON.stringify([...newIds]));
    sessionStorage.setItem(SS_PUSH_NOTIFICATION_LICENSES, JSON.stringify([...newIds]));
}

export function getLicenseIdsPushNotification() {
    let localStorageIds = localStorage.getItem(SS_PUSH_NOTIFICATION_LICENSES);
    localStorageIds = localStorageIds && localStorageIds !== 'undefined' ? JSON.parse(localStorageIds) : [];
    // TODO ローカルストレージにPush通知を溜め込むとシステムが動作しなくなるため、暫定対策でローカルストレージを空にする
    localStorageIds = [];
    let sessionStorageIds = sessionStorage.getItem(SS_PUSH_NOTIFICATION_LICENSES);
    sessionStorageIds = sessionStorageIds && sessionStorageIds !== 'undefined' ? JSON.parse(sessionStorageIds) : [];

    return [...localStorageIds].length > 0 ? localStorageIds : sessionStorageIds;
}

export function updateIsNewLicenseIds(ids = []) {
    saveLicenseIdsPushNotification(ids);
    const formData = new FormData;
    if ([...ids].length > 0) {
        [...ids].map(id => {
            formData.append('ids[]', id);
        });
    } else {
        formData.append('ids', '');
    }
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/members/license/update-new-licenses',
        type: 'POST',
        dataType: 'JSON',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
            //
        },
    });
}

export function arrayColumn(array, column) {
    return array.map((x) => x[column]);
}

export function arrayDiff(arr1, arr2) {
    return arr1.filter((x) => !arr2.includes(x));
}

const commonJs = {
    debounce: function (func, wait, immediate) {
        let timeout;
        return function () {
            const context = this, args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },
    getErrorMessage: function (elm, response) {
        if (response && response.status && ![422, 302].includes(response.status)) {
            location.reload();
            return;
        }
        $('.is-invalid').removeClass(CLASS_VALIDATE_ERROR_INLINE);
        elm.parent().find('.alert').remove();
        $('.loading-wrap').hide();
        $('body').find('.active-error').removeClass('active-error');
        if (elm.closest('.modal').length > 0) {
            elm.closest('.modal').animate({scrollTop: 0}, 300);
        } else {
            $('html, body').animate({scrollTop: 0}, 300);
        }
        let messages = [];

        if (response && typeof response['responseJSON'] !== 'undefined') {
            const error = response['responseJSON'];
            const errors = (typeof error.errors !== 'undefined') ? error.errors : {};
            if (Object.keys(errors).length > 0) {
                $.each(errors, (key, value) => {
                    let element = document.getElementsByName(key);
                    messages.push(typeof value === "object" ? value.join('') : value);
                    if (element && element.length) {
                        element.forEach(function (item) {
                            if ($(item).closest('fieldset:disabled').length <= 0) {
                                item.classList.add(...CLASS_VALIDATE_ERROR);
                            }
                        });
                    }

                    let elementError;
                    switch (key) {
                        case 'code':
                            elementError = $('#area_code, #vehicle_code, #backup_code');
                            break;
                        case 'vehicle_body':
                            elementError = $('#vehicle_body_1, #vehicle_body_2, #vehicle_mode_number, #vehicle_body_number');
                            break;
                        case 'specified_time_ends':
                            elementError = [
                                $('[name=specified_hour_ends]'),
                                $('[name=specified_minute_ends]'),
                            ];
                            break;
                        case 'ble_id':
                            elementError = $('#ble_device_mode_number');
                            break;
                        case 'available_time_starts_at':
                            elementError = [
                                $('[name=available_date_start]'),
                                $('[name=available_hour_start]'),
                                $('[name=available_minute_start]'),
                                $(`[name=available_date_start]`)
                                    .closest('.input-group')
                                    .find('.input-group-prepend .input-group-text'),
                            ];
                            break;
                        case 'available_time_ends_at':
                            elementError = [
                                $('[name=available_date_end]'),
                                $('[name=available_hour_end]'),
                                $('[name=available_minute_end]'),
                                $(`[name=available_date_end]`)
                                    .closest('.input-group')
                                    .find('.input-group-prepend .input-group-text'),
                            ];
                            break;
                        case 'from':
                        case 'to':
                        case 'available_date_start':
                        case 'available_date_end':
                            elementError = $(`[name=${key}]`).closest('.input-group')
                                .find('.input-group-prepend .input-group-text');
                            break;
                        default:
                            break;
                    }
                    if (elementError) {
                        if (elementError.length > 1) {
                            [...elementError].map(el => $(el).addClass(CLASS_VALIDATE_ERROR_INLINE));
                        }
                        $(elementError).addClass(CLASS_VALIDATE_ERROR_INLINE);
                    }
                });
            }
            if (typeof error.data !== 'undefined' &&
                error['data'] !== null &&
                typeof error['data']['failures'] !== 'undefined'
            ) {
                messages = error['data']['failures'];
            }
            if (typeof error.data !== 'undefined' &&
                error['data'] === null &&
                typeof error['message'] !== 'undefined' &&
                error['message']
            ) {
                messages = [error['message']];
            }
        }
        if (messages.length > 0) {
            const message = [...new Set(messages)].map((message) => {
                return `<div>${message}</div>`;
            }).join('');
            elm.parent().prepend(`
            <div class="alert alert-danger" role="alert">
                <button type="button" class="close" data-dismiss="alert">
                    <span aria-hidden="true">&times;</span>
                </button>
                ${message}
            </div>`);
        }
    },
    showLoading: (container = $("body")) => {
        commonJs.hideLoading(container);
        container.append(`<div id='loading'></div>`);
    },
    hideLoading: (container = $("body")) => {
        container.find("#loading").remove();
    },
};

export const debounce = commonJs.debounce;
export const getErrorMessage = commonJs.getErrorMessage;
export const showLoading = commonJs.showLoading;
export const hideLoading = commonJs.hideLoading;
export const defaultLeafletMapOption = {
    minZoom: 6,
    maxZoom: 18,
    zoom: 17,
    zoomControl: false,
    doubleClickZoom: false,
};
export const gsiTileLayer = typeof L !== 'undefined' ? L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
    // option
}) : null;
export const gsiPaleTileLayer = typeof L !== 'undefined' ? L.tileLayer('http://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png', {
    // option
}) : null;
export const formatDigit = (str) => (str).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
})
export const LOCATION_PIN_URL = '/img/pin.svg';
export const pinIcon = typeof L !== 'undefined' ? L.icon({
    iconUrl: LOCATION_PIN_URL,
    iconSize: [40, 40],
    iconAnchor: [40, 40],
}) : null;
export const common = {...commonJs};
